/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { instancesGetBySlug } from "../funcs/instancesGetBySlug.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetInstanceResult } from "../models/components/getinstanceresult.js";
import {
  GetInstanceRequest,
  GetInstanceSecurity,
} from "../models/operations/getinstance.js";
import { unwrapAsync } from "../types/fp.js";
export type InstanceQueryData = GetInstanceResult;

export function prefetchInstance(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetInstanceRequest,
  security?: GetInstanceSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildInstanceQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildInstanceQuery(
  client$: GramCore,
  request: GetInstanceRequest,
  security?: GetInstanceSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<InstanceQueryData>;
} {
  return {
    queryKey: queryKeyInstance({
      toolsetSlug: request.toolsetSlug,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
      gramKey: request.gramKey,
      gramChatSession: request.gramChatSession,
    }),
    queryFn: async function instanceQueryFn(ctx): Promise<InstanceQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(instancesGetBySlug(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyInstance(
  parameters: {
    toolsetSlug: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
    gramKey?: string | undefined;
    gramChatSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "instances", "getBySlug", parameters];
}
